import { useNavigate, useParams } from 'react-router-dom';
import { post } from '../Auths/AuthToken';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import setUiMessage from '../../Utilities/Tostify';
import { useEffect, useState } from 'react';
import PatientSerchPopUpForApp from '../PatientSerchPopUpForApp';
import AddNote from '../Notes/AddNote';
import { useDispatch, useSelector } from 'react-redux';
import { setSeltSerchPat } from '../../redux/slices/patient/patientSlice';
import { setPhoneNotePopup } from '../../redux/slices/Notes/counsellingNoteSlice';
import Button from '../Button';

function ProfileMenu({ handletabs, activeTab, handleAddtreatmentPlan }) {
  const { appId, patientId } = useParams();
  const [patSerchPopup, setPatSerchPopup] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { selectedSerchPat } = useSelector((store) => store.patient);
  const { phoneNote } = useSelector((store) => store.counsellingNote);
  const [patForNete, setPatForNote] = useState(false);
  const handleNoteView = async () => {
    try {
      const response = await post(
        'api/patient/ProgressNote/counselingNoteList',
        {
          patientId: patientId,
          dos: '',
          tov: '',
          noteSt: '',
          provId: '',
          provSignSt: '',
          coSigner: '',
          coSignerSt: '',
          actionSt: '',
          serviceCode: '',
          billSt: '',
          staffUserId: user?.id,
        }
      );
      if (response.status === 200) {
        if (response?.data) {
          response?.data?.counNote.some((element) => {
            if (element.note_type === '3') {
              navigate(
                `${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}/${element.appointmentId}/${element.visitId}`
              );
              return true;
            }
            return false;
          });
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCleateNote = () => {
    if (patientId) {
      setPatForNote(patientId);
    } else {
      dispatch(setSeltSerchPat({}));
      setPatSerchPopup(true);
      dispatch(setPhoneNotePopup(true));
    }
  };

  useEffect(() => {
    if (phoneNote) {
      setPatForNote(selectedSerchPat?.patId);
    } else {
      setPatForNote(false);
    }
  }, [selectedSerchPat?.patId, phoneNote]);

  const handleCLosePopup = () => {
    if (patientId) {
      setPatForNote(false);
    } else {
      dispatch(setSeltSerchPat({}));
    }
    dispatch(setPhoneNotePopup(false));
  };

  return (
    <div className="c-mid-bdy-hdr clear-top10 note-pane flex-sec justify-between item-center">
      <div>
        <span
          className={
            activeTab === 'counNote'
              ? 'widget-hdr-title h-active-t'
              : 'widget-hdr-title'
          }
          onClick={() => handletabs('counNote')}
        >
          Counseling Notes
        </span>

        <span
          className={
            activeTab === 'treatPlan'
              ? 'widget-hdr-title h-active-t'
              : 'widget-hdr-title'
          }
          onClick={() => handletabs('treatPlan')}
        >
          Treatment Plan
        </span>
      </div>
      {patientId ? (
        appId ? (
          <Button variant="secondary" onClick={() => handletabs('counNote')}>
            Go to the List view
          </Button>
        ) : (
          <>
            <Button variant="secondary" onClick={handleNoteView}>
              Go to the Note view
            </Button>
            {activeTab === 'counNote' && (
              <Button
                veriant="primary"
                style={{ marginTop: '-10px' }}
                onClick={handleCleateNote}
              >
                Add Note
              </Button>
            )}
          </>
        )
      ) : (
        activeTab === 'counNote' && (
          <Button
            variant="primary"
            onClick={handleCleateNote}
            style={{ marginTop: '-10px' }}
          >
            Add Note
          </Button>
        )
      )}

      <span className="t-plan-tem-list hide">&#9776;</span>
      {activeTab === 'treatPlan' && !appId && patientId && (
        <Button onClick={handleAddtreatmentPlan} variant="primary">
          Add plan
        </Button>
      )}
      {patSerchPopup && (
        <PatientSerchPopUpForApp
          handleClosePatSerch={() => setPatSerchPopup(false)}
        />
      )}
      {patForNete && (
        <AddNote patId={patForNete} handleClose={handleCLosePopup} />
      )}
    </div>
  );
}

export default ProfileMenu;
